module.exports = __webpack_public_path__ + "static/media/tulogger-logo.a3cb1742.png";